import { render, staticRenderFns } from "./NameTable.vue?vue&type=template&id=afc16888"
import script from "./NameTable.vue?vue&type=script&lang=js"
export * from "./NameTable.vue?vue&type=script&lang=js"
import style0 from "./NameTable.vue?vue&type=style&index=0&id=afc16888&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports